
define('text!modules/reporting/campaigns/geoPerformance/templates/geoPerformance.html',[],function () { return '<div class="w-panel-body w-geo-performance-panel"></div>\n';});

